<template>
  <div class="loge">
  
    <Protocol 
      v-for="protocol in Protocols"
      v-bind:key="'prot' + protocol.id"
      v-bind:title="protocol.title"
      v-bind:created_on="protocol.created_on"
      v-bind:urlId="protocol.protocol"
       />
      <Meeting 
      v-for="meeting in Meetings"
      v-bind:key="'meeting' + meeting.id"
      v-bind:title="meeting.title"
      v-bind:date="meeting.date"
      v-bind:time="meeting.time"
      v-bind:organization="meeting.organization"
      v-bind:premeeting="meeting.premeeting"
      v-bind:adress="meeting.adress"
       />
    <Song
      v-for="song in Songs"
      v-bind:key="'song' + song.id"
      v-bind:title="song.title"
      v-bind:text="song.text"
      v-bind:music="song.music"
    />
  </div>
</template>
<script>
import Song from "../components/Song";
import Protocol from "../components/Protocol";
import Meeting from "../components/Meeting";
import rest from "../rest";
export default {
  name: "loge",
  components: {
    Song,
    Protocol,
    Meeting
  },
  data() {
    return {
      Protocols: null,
      Meetings: null,
      Songs: null
    };
  },
  mounted() {
    rest.songs().then(response => {
      this.Songs = response.data.data;
    });
    rest.meetings().then(response => {
      this.Meetings = response.data.data;
    });
    rest.protocols().then(response => {
      this.Protocols = response.data.data;
    });
  }
};
</script>